/**
 * Provide the WebSite´s {@link Organization | publisher}. This is used, for
 * example, in the imprint or in the general terms.
 *
 * @module
 *
 * @import {Organization} from '../ts/core/publisher';
 *
 * @see [../../html/hook/imprint.html]
 */

import {parseScriptElementAsJson} from '@acng/frontend-bounty/parse.js';
import {extend} from '@acng/frontend-bounty/object.js';
import {guard, OBJECT, STRING} from '@acng/frontend-rubicon';
import {t} from '../locale/config/translate.js';

/**
 * Validate the WebSite´s publisher organization address data.
 */
const ADDRESS = /* @__PURE__ */ OBJECT({
  streetAddress: STRING,
  postalCode: STRING,
  addressLocality: STRING,
  addressCountry: STRING,
});

/**
 * Validate the WebSite´s publisher organization data.
 */
const ORGANIZATION = /* @__PURE__ */ OBJECT({
  name: STRING,
  alternateName: STRING,
  address: ADDRESS,
  telephone: STRING,
  faxNumber: STRING,
  url: STRING,
  email: STRING,
  legalRepresentative: STRING,
  companyRegistration: STRING,
  vatID: STRING,
});

const data = parseScriptElementAsJson('publisher');
ASSERT: guard(data, ORGANIZATION, 'webpage publisher data');

/**
 * @type {Organization}
 */
const publisher = extend(data, {
  address: extend(data.address, {
    addressCountry: () => t(`countries.iso.${data.address.addressCountry}`),
  }),
});

export {publisher};
